import React, { useEffect, useMemo } from 'react';
import { AppFeatures, canIUse } from '../../helpers/PermissionUtility';
import { useAppSelector } from '../../hooks/ReduxHooks';
import { useUserPersistedState } from '../../persistedstate/users/useUserPersistedState';
import GlobalBanner from '../../components/banner/GlobalBanner';

export default function DunningBanner(props: { shouldShow: boolean }) {
  const isManageSubscriptionFlagEnabled = canIUse(AppFeatures.ManageSubscription);
  const dunningStatus = useAppSelector<boolean>((state) => state.profile.client.dunningStatus);
  const [persistedDismissedDunningBanner, setPersistedDismissDunningBanner] = useUserPersistedState('dismissDunningBanner');

  const shouldShowDunningBanner = useMemo(() => {
    if (isManageSubscriptionFlagEnabled && dunningStatus && persistedDismissedDunningBanner != null) {
      return !persistedDismissedDunningBanner ?? true;
    }
    return false;
  }, [isManageSubscriptionFlagEnabled, dunningStatus, persistedDismissedDunningBanner]);

  const onBannerDismiss = () => {
    setPersistedDismissDunningBanner(true);
  };

  useEffect(() => {
    // Reset dismissed state when dunning is false and banner is dismissed, allowing it to reappear if dunning is re-enabled.
    if (dunningStatus != null && !dunningStatus && persistedDismissedDunningBanner) {
      setPersistedDismissDunningBanner(false);
    }
  }, [dunningStatus, persistedDismissedDunningBanner]);

  return (
    <>
      {shouldShowDunningBanner && props.shouldShow && (
        <GlobalBanner
          message={
            <>
              <b>We were unable to process your payment:</b>
              &nbsp;Visit the <a href="/billing">Billing</a> page and confirm that your payment details are correct.
            </>
          }
          handleDismiss={onBannerDismiss}
        />
      )}
    </>
  );
}
